import { usePaymentAttemptsTable } from '@/components/modules/PaymentAttempts/shared/hooks/usePaymentAttemptsTable';

import { PasswordRecoveryListTableRow } from './PasswordRecoveryListTableRow';

export interface PasswordRecovery {
  createdAt: Date;
  updatedAt: Date;
  id: string;
  userId: string;
  hasBeenUsed: boolean;
  expirationDate: Date;
  canBeUsedToChangePassword: boolean;
}

interface PasswordRecoveryListTableBodyProps {
  passwordRecoveryList: PasswordRecovery[];
}

export const PasswordRecoveryListTableBody = ({ passwordRecoveryList }: PasswordRecoveryListTableBodyProps) => {
  const { classes } = usePaymentAttemptsTable();
  return (
    <>
      {passwordRecoveryList
        .sort((a, b) => (b.createdAt.getTime() > a.createdAt.getTime() ? 1 : -1))
        .map((passwordRecovery, i) => {
          return (
            <PasswordRecoveryListTableRow key={i} passwordRecoveryProps={passwordRecovery} className={classes.root} />
          );
        })}
    </>
  );
};
